"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setManager = exports.setIsTeacher = exports.setUserInfo = exports.setToken = void 0;
const actionTypes_1 = require("./actionTypes");
const setToken = (token) => {
    // token.refresh_token && setCookie('refresh_token', token.refresh_token, 1);
    return {
        type: actionTypes_1.SET_TOKEN,
        token,
    };
};
exports.setToken = setToken;
// user 정보 업데이트
const setUserInfo = (user, isTeacher) => {
    return {
        type: actionTypes_1.SET_USER_INFO,
        user,
        isTeacher,
    };
};
exports.setUserInfo = setUserInfo;
const setIsTeacher = (isTeacher) => {
    return {
        type: actionTypes_1.SET_IS_TEACHER,
        isTeacher,
    };
};
exports.setIsTeacher = setIsTeacher;
const setManager = (manager) => {
    return {
        type: actionTypes_1.SET_MANAGER,
        manager,
    };
};
exports.setManager = setManager;
